import type { ColumnDef } from "@tanstack/react-table";
import { DateCell } from "@/components/shared/cells/date-cell";
import { DataTableRowActions } from "./cells/actions";
import { CountCell } from "./cells/count";
import { ExportTypeCell } from "./cells/exportType";
import { StackNameCell } from "./cells/stack-name";
import { StateCell } from "./cells/state";
import { ActionsHeader } from "./headers/actions";
import { CountHeader } from "./headers/count";
import { CreatedAtHeader } from "./headers/created-at";
import { ExportTypeHeader } from "./headers/export-type";
import { StackNameHeader } from "./headers/stack-name";
import { StateHeader } from "./headers/state";

const exportTypeColumn: ColumnDef<any> = {
  id: "exportType",
  size: 250,
  accessorKey: "exportType",
  header: (columns) => <ExportTypeHeader {...columns} />,
  cell: (cell) => <ExportTypeCell {...cell} />,
};

const exportStackNameColumn: ColumnDef<any> = {
  id: "exportStackName",
  accessorKey: "stackName",
  header: (columns) => <StackNameHeader {...columns} />,
  cell: (cell) => <StackNameCell {...cell} />,
};

const exportCountColumn: ColumnDef<any> = {
  id: "exportCount",
  accessorKey: "count",
  header: (columns) => <CountHeader {...columns} />,
  cell: (cell) => <CountCell {...cell} />,
};

const exportStatusColumn: ColumnDef<any> = {
  id: "exportStatus",
  accessorKey: "state",
  header: (columns) => <StateHeader {...columns} />,
  cell: (cell) => <StateCell {...cell} />,
};

const exportDateColumn: ColumnDef<any> = {
  id: "exportDate",
  accessorKey: "exportedAt",
  header: (columns) => <CreatedAtHeader {...columns} />,
  cell: (cell) => <DateCell value={new Date(cell.row.original.exportedAt)} />,
};

const actionsColumn: ColumnDef<any> = {
  id: "actions",
  size: 250,
  header: (columns) => <ActionsHeader {...columns} />,
  cell: ({ row }) => <DataTableRowActions row={row} />,
};

export const columns = [
  exportTypeColumn,
  exportStackNameColumn,
  exportCountColumn,
  exportStatusColumn,
  exportDateColumn,
  actionsColumn,
];
